import { render, staticRenderFns } from "./reduceMoneyPopup.vue?vue&type=template&id=5b2ecfda&scoped=true"
import script from "./reduceMoneyPopup.vue?vue&type=script&lang=js"
export * from "./reduceMoneyPopup.vue?vue&type=script&lang=js"
import style0 from "./reduceMoneyPopup.vue?vue&type=style&index=0&id=5b2ecfda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ecfda",
  null
  
)

export default component.exports